import { Grid } from "@material-ui/core";
import React from "react";
import styled, { css } from "styled-components";
import { ButtonProps, PrimaryButton } from "../../components/button";
import { DateField } from "../../components/forms/date";
import { Password } from "../../components/forms/password";
import { TextField } from "../../components/forms/text";
import { Flex } from "../../components/layout";
import { colours } from "../../styles/colours";

const padding = css`
  &:not(:last-child) {
    margin-bottom: 1.2em;
  }
`;

export const Fields = styled(Flex)`
  ${padding}
`;

export const StyledTextField = styled(TextField)`
  ${padding}
`;

export const StyledPassword = styled(Password)`
  ${padding}
`;

export const StyledDateField = styled(DateField)`
  ${padding}
`;

export const Section = styled(Grid).attrs({ container: true, spacing: 3 })`
  &:not(:first-child) {
    border-top: 1px solid ${colours.lightGrey};
    padding-top: 2em;
    margin-bottom: 0;
    margin-top: 2em;
  }
`;

const CTAWrapper = styled(Flex).attrs({ center: true })`
  margin: 0 auto;
  padding-top: 2em;
  width: 13em;
`;

export const CTA: React.FunctionComponent<ButtonProps> = (props) => (
  <CTAWrapper>
    <PrimaryButton {...props} type="submit" variant="contained" fullWidth />
  </CTAWrapper>
);

export const ButtonWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 1em;
  }
`;